import { useState } from "react";

interface Props {
  onSubmit: (description: string) => void;
  busy: boolean;
}

const EXAMPLES = [
  "two scrambled eggs and a slice of toast with butter",
  "grilled chicken salad with ranch dressing",
  "turkey sandwich on whole wheat with mayo, lettuce, tomato",
  "bowl of oatmeal with banana and almond butter"
];

export default function DescribeCapture({ onSubmit, busy }: Props) {
  const [text, setText] = useState("");

  function submit() {
    const t = text.trim();
    if (!t) return;
    onSubmit(t);
  }

  return (
    <div className="p-4 space-y-4">
      <p className="text-sm text-slate-400">
        Type what you ate — AI will estimate the macros. Be specific about portions when you can ("1 cup", "2 slices").
      </p>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g. two scrambled eggs and a slice of toast with butter"
        rows={4}
        autoFocus
        className="w-full bg-slate-900 border border-slate-800 rounded-lg p-3 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-emerald-500"
      />

      <div>
        <div className="text-xs text-slate-500 mb-2">Try:</div>
        <div className="flex flex-wrap gap-2">
          {EXAMPLES.map((ex) => (
            <button
              key={ex}
              type="button"
              onClick={() => setText(ex)}
              className="text-xs px-2 py-1 rounded-full bg-slate-800 text-slate-300 hover:bg-slate-700"
            >
              {ex.split(" ").slice(0, 3).join(" ")}…
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={submit}
        disabled={!text.trim() || busy}
        className="w-full py-3 rounded-lg bg-emerald-500 text-slate-950 font-semibold disabled:opacity-40"
      >
        {busy ? "Estimating…" : "Estimate macros with AI"}
      </button>
    </div>
  );
}
